//
//
//
//
//
//

import chartEffects from '~/plugins/mixins/chart-effects';
export default {
  mixins: [chartEffects],
  props: {
    reports: {
      type: Array,
      required: true,
    },
  },
  computed: {
    data() {
      return {
        labels: this.reports.map(r => this.$dateFns.format(r.date || r.created_at, 'MMMM yyyy')),
        datasets: [
          {
            label: 'Voedselarm',
            data: this.reports.map(r => r.state_values.acidity.voedselarm.total),
            backgroundColor: 'rgba(245, 76, 62, 0.3)',
            borderColor: 'rgba(245, 76, 62, 1)',
            borderWidth: 2,
          },
          {
            label: 'Matig voedselrijk',
            data: this.reports.map(r => r.state_values.acidity.matig_voedselrijk.total),
            backgroundColor: 'rgba(248, 145, 49, 0.3)',
            borderColor: 'rgba(248, 145, 49, 1)',
            borderWidth: 2,
          },
          {
            label: 'Matig tot zeer voedselrijk',
            data: this.reports.map(r => r.state_values.acidity.matig_tot_zeer_voedselrijk.total),
            backgroundColor: 'rgba(243, 180, 63, 0.3)',
            borderColor: 'rgba(243, 180, 63, 1)',
            borderWidth: 2,
          },
          {
            label: 'Zeer voedselrijk',
            data: this.reports.map(r => r.state_values.acidity.zeer_voedselrijk.total),
            backgroundColor: 'rgba(0, 132, 141, 0.3)',
            borderColor: 'rgba(0, 132, 141, 1)',
            borderWidth: 2,
          },
          {
            label: 'Zuur',
            data: this.reports.map(r => r.state_values.acidity.zuur.total),
            backgroundColor: 'rgba(181, 199, 66, 0.3)',
            borderColor: 'rgba(181, 199, 66, 1)',
            borderWidth: 2,
          },
          {
            label: 'Zwak zuur',
            data: this.reports.map(r => r.state_values.acidity.zwak_zuur.total),
            backgroundColor: 'rgba(117, 177, 73, 0.3)',
            borderColor: 'rgba(117, 177, 73, 1)',
            borderWidth: 2,
          },
          {
            label: 'Basisch',
            data: this.reports.map(r => r.state_values.acidity.basisch.total),
            backgroundColor: 'rgba(238, 157, 204, 0.3)',
            borderColor: 'rgba(238, 157, 204, 1)',
            borderWidth: 2,
          },
        ],
      };
    },
    options() {
      return {
        responsive: true,
        legend: {
          display: true,
          onHover: this.onHover,
          onLeave: this.onLeave,
        },
        title: {
          display: true,
          text: 'Trofietoestand en zuurgraad',
          fontSize: 24,
          fontColor: '#6b7280',
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Aantal soorten',
            },
          }],
        },
      };
    },
  },
};
